import { MutationHookOptions, useMutation } from "@apollo/client";
import gql from "graphql-tag";

export const UPDATE_SURVEY_INFO = gql`
mutation UpdateSurveyInfo($survey_id: uuid!, $internal_name: String!, $name: String!, $description: String) {
  update_SUR_survey_by_pk(pk_columns: {id: $survey_id}, _set: {internal_name: $internal_name, name: $name, description: $description}) {
    id
    internal_name
    name
    description
  }
}
`;

export interface UpdateSurveyInfoData {
  update_SUR_survey_question_option_by_pk: {
    id: string;
    internal_name: string;
    name: string;
    description: string | null;
  }
}

export interface UpdateSurveyInfoVariables {
  survey_id: string;
  internal_name: string;
  name: string;
  description?: string | null;
}

export function useUpdateSurveyInfoMutation(
  options?:
    | MutationHookOptions<UpdateSurveyInfoData, UpdateSurveyInfoVariables>
    | undefined
) {
  return useMutation<UpdateSurveyInfoData, UpdateSurveyInfoVariables>(
    UPDATE_SURVEY_INFO,
    options
  );
}
